import { FC } from "react"
import { PageTemplate } from "../components/pageTemplate/PageTemplate"

export const Disclaimer: FC = () => {
  return (
    <PageTemplate
      pageTitle="Disclaimer"
      pageContentClassName="info-page-container"
    >
      <article className="d-flex align-items-center flex-column">
        <section className="info-page-txt">
          <div className="sidebar-content-container">
            <header>Disclaimer</header>
            <p>
              As the Online Coordination System provides a real time slot
              allocation system and is continually updated by users, the
              availability of slots changes constantly. While the OCS Portal
              Administrator does its utmost to ensure that the information
              available via the website is correct and up-to-date, no slot
              allocation can be confirmed until the user has received a
              confirmation from the Coordinator that the request has been
              accepted. Please see also Slot Availability info below. You agree
              that you will not hold the participating Coordinator liable for
              direct, indirect or consequential loss, damages or expenses
              incurred or suffered by you as a result of any matter arising from
              or related to, the information on slot availability, and the
              participating Coordinators liability for such loss, damages or
              expenses is excluded to the maximum extent permitted by law.
            </p>
          </div>
          <div className="sidebar-content-container">
            <header>Slot Availability</header>
            <p>
              The slot availability displays only show runway slot availability.
              Other constraints, such as terminal or stand capacity or night
              period restrictions, may prevent slots being allocated as
              requested. The aircraft operator is responsible for complying with
              any and all additional restrictions or conditions that may apply
              to the operation of a flight at the airport concerned and must
              check the relevant publications (eg, NOTAMs, the Airport’s
              Conditions of Use, etc).
            </p>
            <p>
              The allocation of a slot does not imply the availability of all
              facilities necessary for the operation. In all cases it is the
              aircraft operator’s responsibility to make suitable ground
              handling arrangements.
            </p>
          </div>
        </section>
      </article>
    </PageTemplate>
  )
}
